import React, { useState,CSSProperties } from 'react';
import { Box, Button, Table, Thead, Tbody, Tr, Th, Td,useToast, Image, IconButton, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Flex, FormControl, FormLabel, Input, Textarea, Select } from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {deletejobPost, getJobPosts, updateJobPosts} from './redux/postslice'
import ClipLoader from "react-spinners/ClipLoader";
import 'toastr/build/toastr.min.css';
import toastr from 'toastr'

import { UseSelector,useDispatch, useSelector } from 'react-redux';
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
function App() {
  let toast=useToast()
  const [jobs, setJobs] = useState([
   
  ]);

  const [editJobModalOpen, setEditJobModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [step, setStep] = useState(1);
  const [editedJob, setEditedJob] = useState(null);

const dispatch=useDispatch();
let loading=useSelector(state=>state?.jobpost?.loading)
React.useEffect(()=>{
  fetchJobPosts()
},[])
const fetchJobPosts=async()=>{
  let fetchjobpostRes=await dispatch(getJobPosts())
if(getJobPosts.rejected.match(fetchjobpostRes)){
console.log(fetchjobpostRes)
}
if(getJobPosts.fulfilled.match(fetchjobpostRes)){
setJobs((prev)=>{
  return fetchjobpostRes?.payload?.data?.jobposts

})
}
}


  const handleEditJob = (job) => {
    setSelectedJob(job);
    setStep(1);
    setEditedJob({ ...job });
    setEditJobModalOpen(true);
  };

  const handleCloseEditJobModal = () => {
    setSelectedJob(null);
    setStep(1);
    setEditedJob(null);
    setEditJobModalOpen(false);
  };

  const handleNextStep = () => {
    setStep(step + 1);
  };

  const handlePreviousStep = () => {
    setStep(step - 1);
  };

  const handleUpdateJob = async() => {
    const updatedJobs = jobs.map(job => (job?._id === editedJob?._id ? editedJob : job));
    console.log("updated")
    console.log(editedJob)
    let form=new FormData();
    form.append('jobTitle',editedJob.jobTitle)
    form.append('companyName',editedJob.companyName)
     form.append('image',editedJob.companyLogo)
     form.append('numberOfEmployees',editedJob.numberOfEmployees)
      form.append('servicesOffered',editedJob.servicesOffered)
      form.append('experienceRequired',editedJob.experienceRequired)
  form.append('jobType',editedJob.jobType)
  form.append('jobDescription',editedJob.jobDescription)
  form.append('id',editedJob?._id)
    

    let updatedjobsres=await dispatch(updateJobPosts(form))
if(updateJobPosts.rejected.match(updatedjobsres)){
  console.log(updatedjobsres)
  toast({
    title: 'Server error please try later',
    status: 'error',
    duration: 3000,
    isClosable: true,
  });
}
if(updateJobPosts.fulfilled.match(updatedjobsres)){
  toast({
    title: 'Post updated sucessfully',
    status: 'success',
    duration: 3000,
    isClosable: true,
  });
}

console.log(updatedJobs)
    // setJobs(updatedJobs);
    handleCloseEditJobModal();
  };

  const handleChange = (e) => {

    const { name, value } = e.target;
    setEditedJob(prevState => ({
      ...prevState,
      [name]: value
    }));
    
  };

  const handleLogoChange = (e) => {
  
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setEditedJob(prevState => ({
        ...prevState,
        companyLogo: file
      }));
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteJob = async(id) => {

  let deleteres=await dispatch(deletejobPost(id))
  if(deletejobPost.rejected.match(deleteres)){
    toast({
      title: 'Server error please try later',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  }
  if(deletejobPost.fulfilled.match(deleteres)){
    console.log(deleteres)
    setJobs(jobs.filter(job => job?._id !== id));

    toast({
      title: 'Job deleted successfully',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  }


  };
  return (
    <>
    {loading?<ClipLoader
        color="#ffffff"
        loading={loading}
        cssOverride={override}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />:<Box className="App" p={8} overflowX="auto">
      <header>
        <h1>Jobs</h1>
        <Table variant="simple" width="100%">
          <Thead>
            <Tr>
              <Th>Job Title</Th>
              <Th>Company</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {jobs?.map((job) => (
              <Tr key={job?._id}>
                <Td>{job?.job_title}</Td>
                <Td>
                  <Flex align="center">
                    <Image src={job?.company_logo} alt="Company Logo" boxSize="50px" borderRadius="full" marginRight="1rem" />
                    {job?.company_name}
                  </Flex>
                </Td>
                <Td>
                  <IconButton
                    aria-label="Delete"
                    icon={<DeleteIcon />}
                    colorScheme="red"
                    variant="ghost"
                    onClick={() => handleDeleteJob(job?._id)}
                    marginRight="0.5rem"
                    />
                  {/* <IconButton
                    aria-label="Edit"
                    icon={<EditIcon />}
                    onClick={() => handleEditJob(job)}
                    marginRight="0.5rem"
                    /> */}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </header>
      {/* Edit Job Modal */}
      <Modal isOpen={editJobModalOpen} onClose={handleCloseEditJobModal} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Job</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {step === 1 && (
              <StepOneForm job={editedJob} onChange={handleChange} onNext={handleNextStep} />
              )}
            {step === 2 && (
              <StepTwoForm job={editedJob} onChange={handleChange} onNext={handleNextStep} onPrevious={handlePreviousStep} />
              )}
            {step === 3 && (
              <StepThreeForm job={editedJob} onChange={handleChange} onNext={handleNextStep} onPrevious={handlePreviousStep} />
              )}
            {step === 4 && (
              <StepFourForm job={editedJob} onChange={handleChange} onPrevious={handlePreviousStep} onSubmit={handleUpdateJob} />
              )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>}
    
</>
  );
}

const StepOneForm = ({ job, onChange, onNext, onLogoChange }) => {
  console.log("logochange")
  console.log(onLogoChange)
  return (
    <form>
      <FormControl>
        <FormLabel>Company Name</FormLabel>
        <Input name="companyName" value={job.companyName} onChange={onChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Company Logo</FormLabel>
        <Input type="file" accept="image/png, image/jpeg" onChange={onLogoChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Number of Employees</FormLabel>
        <Input name="numberOfEmployees" type="number" value={job.numberOfEmployees} onChange={onChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Services Offered</FormLabel>
        <Input name="servicesOffered" value={job.servicesOffered} onChange={onChange} />
      </FormControl>
      <Button mt={4} colorScheme="teal" onClick={onNext}>Next</Button>
    </form>
  );
};

const StepTwoForm = ({ job, onChange, onNext, onPrevious }) => {
  return (
    <form>
      <FormControl>
        <FormLabel>Job Title</FormLabel>
        <Input name="jobTitle" value={job.jobTitle} onChange={onChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Experience Required</FormLabel>
        <Select name="experienceRequired" value={job.experienceRequired} onChange={onChange}>
          <option value="Full Time">Full Time</option>
          <option value="Part Time">Part Time</option>
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>Job Type</FormLabel>
        <Select name="jobType" value={job.jobType} onChange={onChange}>
          <option value="Remote">Remote</option>
          <option value="Hybrid">Hybrid</option>
          <option value="Onsite">Onsite</option>
        </Select>
      </FormControl>
      <Button mt={4} colorScheme="teal" onClick={onPrevious}>Previous</Button>
      <Button mt={4} colorScheme="teal" onClick={onNext} ml={2}>Next</Button>
    </form>
  );
};

const StepThreeForm = ({ job, onChange, onNext, onPrevious }) => {
  return (
    <form>
      <FormControl>
        <FormLabel>Job Description</FormLabel>
        <Textarea name="jobDescription" value={job.jobDescription} onChange={onChange} />
      </FormControl>
      <Button mt={4} colorScheme="teal" onClick={onPrevious}>Previous</Button>
      <Button mt={4} colorScheme="teal" onClick={onNext} ml={2}>Next</Button>
    </form>
  );
};

const StepFourForm = ({ job, onChange, onPrevious, onSubmit }) => {
  return (
    <form>
      <FormControl>
        <FormLabel>Review your changes</FormLabel>

        <Textarea value={JSON.stringify(job, null, 2)} isReadOnly />
      </FormControl>
      <Button mt={4} colorScheme="teal" onClick={onPrevious}>Previous</Button>
      <Button mt={4} colorScheme="teal" onClick={onSubmit} ml={2}>Submit</Button>
    </form>
  );
};

export default App;
